import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { ITheme } from '../models/ITheme';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  constructor(private db: AngularFirestore) { }

  ref = this.db.collection('themes');

  getAll() {
    return this.ref.snapshotChanges().pipe(map(actions => {
      return actions.map(action => {
        return {id: action.payload.doc.id, ...action.payload.doc.data() as ITheme};
      });
    }));
  }

  get(id: string) {
    return this.ref.doc(id).snapshotChanges().pipe(map(action => {
      return {id: action.payload.id, ...action.payload.data() as ITheme};
    }));
  }

  set(theme: ITheme, id: string) {
    if (id) { return this.ref.doc(id).update(theme); }
    else { return this.ref.add(theme); }
  }

  delete(id: string) {
    return this.ref.doc(id).delete();
  }

  uploadImage(file: File) {
    return firebase.storage().ref(`themes/${file.name}`).put(file).then(snapshot => {
      return snapshot.ref.getDownloadURL();
    });
  }
}
